
// @ngInject

Models.QuestionsCollection = function QuestionsCollection(BaseCollection) {

    return Class(BaseCollection, {

            constructor: function constructor(){
                this.constructor.$super.call(this);
                this._collection.__className = 'QuestionsCollection';
                this._collection.__childsType = 'QuestionModel';
                this._collection.shouldMergeOnLoad = false;
                return this._collection;
            }
        }
    );

};
